// Shared loading-safety timer for Team Assist requests. Used by both
// AskTeamAssist (real agent questions) and TriggerTeamAssistFollowUp
// (the auto-fired follow-up after an executed destructive tool) so that
// either action can cancel the other's pending timer — only one
// outstanding Team Assist request per customer should be tracked at a
// time.
//
// The timeout is a safety net for the fire-and-forget path: the
// synchronous POST acknowledges the request and the AI response arrives
// later via MQTT broadcast. If the broadcast is lost or the upstream
// fails server-side without publishing anything, this timer clears the
// loading indicator so the agent isn't stuck staring at a spinner.

export const LOADING_SAFETY_TIMEOUT_MS = 60000;

// Per-customer timer ids so a new request cancels the previous one for
// the same customer rather than letting it fire later and reset loading
// on a still-in-flight request.
const loadingTimeoutsByCustomerId = new Map();

export function startLoadingSafetyTimer(customerId, teamAssists) {
  clearLoadingSafetyTimer(customerId);
  const timeoutId = setTimeout(() => {
    // Re-check ownership: a newer request may have replaced this timer
    // in the window between scheduling and firing.
    if (loadingTimeoutsByCustomerId.get(customerId) !== timeoutId) {
      return;
    }
    loadingTimeoutsByCustomerId.delete(customerId);
    teamAssists.resetLoading();
  }, LOADING_SAFETY_TIMEOUT_MS);
  loadingTimeoutsByCustomerId.set(customerId, timeoutId);
}

export function clearLoadingSafetyTimer(customerId) {
  const timeoutId = loadingTimeoutsByCustomerId.get(customerId);
  if (timeoutId) {
    clearTimeout(timeoutId);
    loadingTimeoutsByCustomerId.delete(customerId);
  }
}
